export default __webpack_public_path__ + "static/media/site-loader.4a60eb82.gif";